import * as Yup from "yup";
import { MenuSituacao, MenuTipo } from "./model";

export class MenuSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um numero positivo");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      nome,
      tipo,
      icone,
      situacao,
      menuPai,
      menusFilho,
      perfis,
      link,
    } = recordShape;

    const createFormShape = {
      nome,
      tipo,
      icone,
      situacao,
      menuPai,
      menusFilho,
      perfis,
      link,
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      nome,
      icone,
      situacao,
      menuPai,
      menusFilho,
      perfis,
      tipo,
      link,
    } = recordShape;

    const updateFormShape = {
      nome,
      icone,
      situacao,
      menuPai,
      menusFilho,
      perfis,
      tipo,
      link,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const recordShape = {
  nome: Yup
    .string()
    .max(32, "Nome deve conter no máximo 32 caracteres")
    .required("Nome é obrigatório"),
  tipo: Yup
    .string()
    .oneOf(Object.values(MenuTipo))
    .required("Tipo é obrigatório"),
  icone: Yup
    .string()
    .optional()
    .nullable(true)
    .max(32, "Ícone deve ter no máximo 32 caracteres"),
  link: Yup
    .string()
    .optional()
    .nullable(true)
    .max(128, "Link deve ter no máximo 128 caracteres"),
  situacao: Yup
    .string()
    .oneOf(Object.values(MenuSituacao))
    .required("Situação é obrigatório"),
  menuPai: Yup.number()
    .when("tipo", {
      is: MenuTipo.FILHO,
      then: Yup
        .number()
        .required("Menu Pai é obrigatório para tipo FILHO"),
      otherwise: Yup
        .number()
        .nullable(true)
        .test("menuPai", "Apenas tipo FILHO pode ter menu pai", (menuPai) => (menuPai ?? null) === null),
    }),
  menusFilho: Yup.array()
    .when("tipo", {
      is: MenuTipo.PAI,
      then: Yup
        .array()
        .of(Yup.number()
          .required("Perfis deve ser um array de números")),
      otherwise: Yup.array()
        .length(0, "Apenas Menus do tipo PAI podem ter filhos"),
    }),
  perfis: Yup.array()
    .when("tipo", {
      is: MenuTipo.FILHO,
      then: Yup
        .array()
        .of(Yup.number()
          .required("Perfis deve ser um array de números")),
      otherwise: Yup.array()
        .length(0, "Apenas Menus do tipo FILHO podem ter perfis"),
    }),
};
